'use strict';
require('./landing.scss');

module.exports = {
  template: require('./landing.html'),
  controller: require('./landing.controller.js'),
  controllerAs: 'vm',
  bindings: {
    'me': '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/landing/landing/index.js
 ** module id = 187
 ** module chunks = 0
 **/